/* Goccia Group — Shopify Forms Shadow DOM style injector */
(function () {
  const CSS = `
    /* Font globale */
    :host {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
    }

    /* Forza il layout interno a occupare tutta la larghezza disponibile */
    [class*="formContainer"],
    [class*="gridItem"],
    [class*="gridItemContent"],
    [class*="formFieldset"],
    [class*="formHeader"],
    form {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    [class*="formContainer"][class*="grid"] {
      display: block !important;
    }

    /* Titolo */
    h1, h2, h3 {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 2rem !important;
      font-weight: 700 !important;
      letter-spacing: -0.01em !important;
      line-height: 1.25 !important;
      color: #0A0A0A !important;
      text-align: left !important;
      margin-bottom: 12px !important;
    }

    /* Sottotitolo — solo il p dentro il blocco testo dell'header del form */
    [class*="textBody"] p,
    [class*="TextBody"] p {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 1.05rem !important;
      font-weight: 400 !important;
      color: #555555 !important;
      line-height: 2 !important;
      letter-spacing: 0.02em !important;
      text-align: left !important;
      margin-bottom: 32px !important;
    }

    /* Rimuove la copertura bianca del floating label che nasconde il bordo */
    [class*="formFieldContainer"]::before,
    [class*="FieldContainer"]::before {
      background-color: transparent !important;
    }

    /* Label */
    label {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.6rem !important;
      font-weight: 700 !important;
      letter-spacing: 0.18em !important;
      text-transform: uppercase !important;
      color: #777777 !important;
      line-height: 1.6 !important;
      margin-bottom: 8px !important;
      text-align: left !important;
      display: block !important;
    }

    /* Input testo */
    input[type="text"],
    input[type="email"],
    input[type="number"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    textarea:not([style*="display: none"]):not([id*="captcha"]):not([name*="captcha"]):not([id*="h-captcha"]):not([name*="h-captcha"]) {
      box-sizing: border-box !important;
      -webkit-box-sizing: border-box !important;
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.9rem !important;
      font-weight: 400 !important;
      color: #0A0A0A !important;
      background: #FFFFFF !important;
      border: 1px solid #D8D8D8 !important;
      border-radius: 0 !important;
      -webkit-border-radius: 0 !important;
      padding: 24px 14px 8px !important;
      min-height: 56px !important;
      width: 100% !important;
      max-width: 100% !important;
      outline: none !important;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      transition: border-color 0.2s ease !important;
      text-align: left !important;
      display: block !important;
    }

    input[type="text"]:focus,
    input[type="email"]:focus,
    input[type="tel"]:focus,
    input[type="number"]:focus,
    textarea:focus {
      border: 1px solid #0A0A0A !important;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      outline: none !important;
      outline-offset: 0 !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: #AAAAAA !important;
      font-weight: 400 !important;
      text-align: left !important;
    }

    textarea {
      min-height: 120px !important;
      resize: vertical !important;
      border-top: 1px solid #D8D8D8 !important;
      border-left: 1px solid #D8D8D8 !important;
      border-right: 1px solid #D8D8D8 !important;
      border-bottom: 1px solid #D8D8D8 !important;
      margin-top: 2px !important;
      margin-left: 1px !important;
      width: calc(100% - 2px) !important;
    }

    /* Telefono — allinea altezza al container con bandiera */
    [class*="formPhoneInputContainer"],
    [class*="phoneInputContainer"] {
      min-height: 56px !important;
      align-items: stretch !important;
    }

    [class*="formPhoneInputContainer"] [class*="selectContainer"],
    [class*="formPhoneInputContainer"] .phone-country-selector {
      min-height: 54px !important;
      width: auto !important;
      max-width: none !important;
      display: flex !important;
      align-items: center !important;
      border-radius: 0 !important;
      box-sizing: border-box !important;
    }

    [class*="formPhoneInputContainer"] [class*="selectToggle"] {
      min-height: 54px !important;
      width: auto !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 4px !important;
      padding: 0 10px !important;
      border-radius: 0 !important;
      -webkit-border-radius: 0 !important;
      box-sizing: border-box !important;
    }

    [class*="formPhoneInputField"],
    [class*="phoneInputField"] {
      min-height: 56px !important;
    }

    /* Select — escluso phone picker */
    select:not([class*="phone"]):not([class*="country"]):not([class*="flag"]):not([class*="dial"]) {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.9rem !important;
      color: #0A0A0A !important;
      background: #FFFFFF !important;
      border: 1px solid #D8D8D8 !important;
      border-radius: 0 !important;
      padding: 12px 36px 12px 14px !important;
      width: 100% !important;
      outline: none !important;
      box-shadow: none !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23777' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
      cursor: pointer !important;
    }

    /* Bottone submit */
    button[type="submit"],
    input[type="submit"],
    [class*="formSubmitButton"],
    [class*="submitButton"],
    [class*="submit-button"] {
      box-sizing: border-box !important;
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.65rem !important;
      font-weight: 700 !important;
      letter-spacing: 0.2em !important;
      text-transform: uppercase !important;
      color: #FFFFFF !important;
      background: #111111 !important;
      border: none !important;
      border-radius: 0 !important;
      -webkit-border-radius: 0 !important;
      padding: 16px !important;
      width: 100% !important;
      max-width: 100% !important;
      cursor: pointer !important;
      display: block !important;
      text-align: center !important;
      transition: background 0.2s ease !important;
      box-shadow: none !important;
      margin-top: 8px !important;
    }

    button[type="submit"]:hover,
    input[type="submit"]:hover,
    [class*="formSubmitButton"]:hover {
      background: #333333 !important;
    }

    /* Errori */
    [class*="error"], [class*="Error"] {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.65rem !important;
      font-weight: 600 !important;
      letter-spacing: 0.05em !important;
      color: #E02229 !important;
      margin-top: 4px !important;
      text-align: left !important;
    }

    /* Successo */
    [class*="success"], [class*="Success"] {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.7rem !important;
      font-weight: 600 !important;
      letter-spacing: 0.12em !important;
      text-transform: uppercase !important;
      color: #0A0A0A !important;
    }

    /* Note legali */
    small,
    [class*="Disclaimer"] p,
    [class*="disclaimer"] p,
    [class*="legal"] p,
    [class*="privacy"] p,
    [class*="consent"] p {
      font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
      font-size: 0.62rem !important;
      font-weight: 400 !important;
      color: #AAAAAA !important;
      letter-spacing: 0.03em !important;
      line-height: 1.65 !important;
      text-align: left !important;
      display: block !important;
      margin-top: 12px !important;
      margin-bottom: 0 !important;
    }

    small a, [class*="disclaimer"] a {
      color: #777777 !important;
      text-decoration: underline !important;
    }

    /* Checkbox / Radio */
    input[type="checkbox"],
    input[type="radio"] {
      width: 16px !important;
      height: 16px !important;
      accent-color: #111111 !important;
      cursor: pointer !important;
      flex-shrink: 0 !important;
    }
  `;

  function injectIntoShadow(host) {
    const root = host.shadowRoot;
    if (!root) return;
    if (root.querySelector('style[data-goccia]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-goccia', '1');
    style.textContent = CSS;
    root.prepend(style);
  }

  function observeHost(host) {
    injectIntoShadow(host);
    const mo = new MutationObserver(() => injectIntoShadow(host));
    mo.observe(host, { childList: true, subtree: true });
  }

  function alignLeft(node) {
    node.style.setProperty('align-self', 'flex-start', 'important');
    node.style.setProperty('margin-left', 'auto', 'important');
    node.style.setProperty('margin-right', 'auto', 'important');
    node.style.setProperty('max-width', '1200px', 'important');
    node.style.setProperty('width', '100%', 'important');
    node.style.setProperty('box-sizing', 'border-box', 'important');
    node.style.setProperty('padding-left', '32px', 'important');
    node.style.setProperty('padding-right', '32px', 'important');
  }

  function init() {
    document.querySelectorAll('shopify-forms-embed').forEach(observeHost);

    const isContactPage = document.querySelector('main[data-template="page.contatti"]');
    if (isContactPage) {
      document.querySelectorAll('.shopify-block, .shopify-app-block, [data-form-root]').forEach(alignLeft);
    }

    const bodyObserver = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'SHOPIFY-FORMS-EMBED') observeHost(node);
          node.querySelectorAll && node.querySelectorAll('shopify-forms-embed').forEach(observeHost);
          if (
            node.classList &&
            (node.classList.contains('shopify-block') ||
             node.classList.contains('shopify-app-block') ||
             node.hasAttribute('data-form-root'))
          ) alignLeft(node);
          node.querySelectorAll && node.querySelectorAll('.shopify-block, .shopify-app-block, [data-form-root]').forEach(alignLeft);
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();